'use client';
import React from 'react';
import UtilityButton from './utilityButton';
import ArrowIcon from '../atoms/icons/arrow';

const ButtonAnchorLink = ({ blok, inTextBlock = false, parentColor }) => {
  const link = { anchor: blok.anchor, linktype: 'anchor' };

  return (
    <UtilityButton
      label={blok.label}
      padding={inTextBlock ? 'mt-4 -mx-4 mb-0' : 'mt-0 mb-4'}
      buttonType={blok.type}
      link={link}
      color={blok.color || 'yellow'}
      parentColor={parentColor}
      icon={<ArrowIcon rotate="rotate-90" />}
    />
  );
};

export default ButtonAnchorLink;
